if(!customElements.get('product-wrapper')) {
    customElements.define('product-wrapper', 
        class ProductWrapper extends HTMLElement {
            constructor () {
                super();

                let _this = this;

                _this.mainSliderEl = this.querySelector('[data-main-slider]');
                _this.thumbSliderEl = this.querySelector('[data-thumbnail-slider]');
                
                _this.mainSliderItems = _this.mainSliderEl.querySelectorAll('.product-main-slide');
                _this.thumbSliderItems = _this.thumbSliderEl.querySelectorAll('.product__thumb-item');

         
                document.addEventListener('variant:change', (e) => {
                    if (e.detail && e.detail.variant) {
                        this.updateVariantId(e.detail.variant.id);
                    }
                });

                setTimeout(() => {
                    this.sliderInit();
                }, 0);
            }

            updateVariantId(variant_id) {
                let variant_info = null;

                let _this = this

                try {
                    const el = this.querySelector('[data-variants-info-wrapper]');
                    
                    if (el && el.textContent) {
                        // Clean the text content before parsing
                        const cleanText = el.textContent
                        .replace(/[\u0000-\u001F\u007F-\u009F]/g, '') // Remove control characters
                        .replace(/&nbsp;/g, ' ') // Replace HTML non-breaking spaces
                        .trim();

                        variant_info = JSON.parse(cleanText);
                    } else {
                        console.warn('Element or textContent missing.');
                    }
                } catch (error) {
                    console.error('Error parsing JSON:', error);
                }


                const selectedVariant = variant_info.find(variant => variant.id == variant_id);

                renderAdditionalInfo(selectedVariant.variantMetafieldsData)
                
                _this.querySelector(".product-single__title").innerHTML = selectedVariant.title;
                _this.querySelector(".product_description .collapsible-content__inner").innerHTML = selectedVariant.description;

                const main_image_id = `main-${variant_id}`;
                const thumb_image_id = `thumb-${variant_id}`;

                _this.mainSlider.slides.forEach(slide => {
                    const slide_id = slide.getAttribute('data-main-id');
                    slide.remove()
                })

                _this.thumbSlider.slides.forEach(slide => {
                    const slide_id = slide.getAttribute('data-thumb-id');
                    slide.remove()
                })

                _this.mainSliderItems.forEach(item => {
                    const slide_id = item.getAttribute('data-main-id');

                    if (slide_id == main_image_id) {
                        _this.mainSlider.appendSlide(item);
                    }
                })

                _this.thumbSliderItems.forEach(item => {
                    const slide_id = item.getAttribute('data-thumb-id');

                    if (slide_id == thumb_image_id) {
                        _this.thumbSlider.appendSlide(item);
                    }
                })

                setTimeout(() => {
                    _this.mainSlider.destroy();
                    _this.thumbSlider.destroy();

                    _this.sliderInit();
                }, 0);

                
            }

            sliderInit () {

                const prevButton = this.thumbSliderEl.querySelector('.product__thumb-arrow--prev');
                const nextButton = this.thumbSliderEl.querySelector('.product__thumb-arrow--next');

                this.thumbSlider = new Swiper(this.thumbSliderEl, {
                    slidesPerView : "auto",
                    spaceBetween : 5,
                    watchOverflow: true,
                    centeredSlides: false,
                    watchSlidesVisibility: true,
                    freeMode: true,
                    navigation: {
                      nextEl: nextButton ? nextButton : null,
                      prevEl: prevButton ? prevButton : null,
                    },
                    watchSlidesProgress: true,
                    direction : "vertical",
                });

                this.mainSlider = new Swiper(this.mainSliderEl, {
                    slidesPerView : "auto",
                    spaceBetween : 10,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    preventInteractionOnTransition: true,
                    thumbs : {
                        swiper : this.thumbSlider,
                    }
                });
            }
        }
    )
}

window.addEventListener('DOMContentLoaded', function (e) {
    const productWrap = document.querySelector('product-wrapper');

    const selectedVariantId = productWrap.dataset.selectedVariantId;

    productWrap.updateVariantId(selectedVariantId)
})

function renderAdditionalInfo(variantMetafieldsData) {
  const container = document.querySelector('.product-additional-info-container .product-additional-info__groups');
  if (!container) return;

  let html = '';
  variantMetafieldsData.forEach(group => {
    // Only show groups with at least one non-empty field
    const groupFields = group.data.filter(item => item.content && item.content.trim() !== '');
    if (groupFields.length === 0) return;

    html += `<div class="product-additional-info__group">
      <div class="product-additional__group--title">${group.title}</div>
      <div class="product-additional__group--info">`;

    groupFields.forEach(item => {
      html += `<div class="product-additional-info--item">
        <div class="adt-info__title">${item.title}</div>
        <div class="adt-info__content">${item.content}</div>
      </div>`;
    });

    html += `</div></div>`;
  });

  container.innerHTML = html;
}

// === Free Shipping Progress Bar in Header ===
function updateHeaderFreeShippingBar() {
  var barContainer = document.querySelector('.header-free-shippingbar');

  const col_1_price = parseFloat(barContainer.getAttribute('data-goal-1'))
  const col_2_price = parseFloat(barContainer.getAttribute('data-goal-2'))
  const col_3_price = parseFloat(barContainer.getAttribute('data-goal-3'))
  const col_4_price = parseFloat(barContainer.getAttribute('data-goal-4'))
  const col_5_price = parseFloat(barContainer.getAttribute('data-goal-5'))


  const col_1_per = parseFloat(barContainer.getAttribute('data-goal-per-1'))
  const col_2_per = parseFloat(barContainer.getAttribute('data-goal-per-2'))
  const col_3_per = parseFloat(barContainer.getAttribute('data-goal-per-3'))
  const col_4_per = parseFloat(barContainer.getAttribute('data-goal-per-4'))
  const col_5_per = parseFloat(barContainer.getAttribute('data-goal-per-5'))

  if (!barContainer) return;

  var freeShippingPrice = col_1_price;

  fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
        var cartTotal = cart.total_price / 100; // Shopify returns cents
        var text = barContainer.querySelector('.header-free-shippingbar__text');
      
        if (text) {
            text.classList.remove('reached')

            if(cartTotal < col_1_price) {
                updateProgressBar(cartTotal, col_1_price, col_1_per)

            }else if(cartTotal > col_1_price && cartTotal <= col_2_price) {
                barContainer.setAttribute('data-free-shipping-price', col_2_price)

                updateProgressBar(cartTotal, col_2_price, col_2_per)
            
            }else if (cartTotal > col_2_price && cartTotal <= col_3_price) {
                barContainer.setAttribute('data-free-shipping-price', col_3_price)

                updateProgressBar(cartTotal, col_3_price, col_3_per)
            }else if (cartTotal > col_3_price && cartTotal <= col_4_price) {
                barContainer.setAttribute('data-free-shipping-price', col_4_price)

                updateProgressBar(cartTotal, col_4_price, col_4_per)
            }else if (cartTotal > col_4_price && cartTotal <= col_5_price) {
                barContainer.setAttribute('data-free-shipping-price', col_5_price)

                updateProgressBar(cartTotal, col_5_price, col_5_per)   
            }else if (cartTotal > 5) {
                text.classList.add('reached')
                updateProgressBar(cartTotal, col_5_price, col_5_per)   
            }
        }
    });
}


function updateProgressBar(cartTotal, freeShippingPrice, percent) {
    var barContainer = document.querySelector('.header-free-shippingbar');

    var progress = Math.min(cartTotal / freeShippingPrice, 1);
    var progressBar = barContainer.querySelector('.header-free-shippingbar__progress');
    var text = barContainer.querySelector('.header-free-shippingbar__text');
    if (progressBar) {
        progressBar.style.width = (progress * 100) + '%';
    }

    var remaining = freeShippingPrice - cartTotal;
    var formatted = (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function')
    ? window.theme.Currency.formatMoney(Math.round(remaining * 100), window.theme.settings.moneyFormat)
    : remaining.toFixed(2);

    text.querySelector('.shipping-progress__price').textContent = formatted;
    text.querySelector('.shipping-goal__percent').textContent = percent + "%";
}

document.addEventListener('DOMContentLoaded', updateHeaderFreeShippingBar);
document.addEventListener('cart:updated', updateHeaderFreeShippingBar);
document.addEventListener('cart:refresh', updateHeaderFreeShippingBar);